import React from 'react';
import { TABLET_MIN_WIDTH } from '../../../utils';
import { CompareState } from '../../types';
import Header from './Header/Header';
import Content from './Content/Content';
import Footer from './Footer/Footer';
const FaresSlider = ({ headerRef, isLoading, compareTable, selectedFare, selectedFareName, error, notes }) => {
    const topSliderRef = React.useRef();
    const contentTableRef = React.useRef();
    const [currentSlide, setCurrentSlide] = React.useState(0);
    const [compareState, onCompareStateChange] = React.useState(CompareState.CompareFares);
    const sliders = [];
    let compareFaresSlidesCount, fullCompareFaresSlidesCount;
    const isFullFareConditions = compareState === CompareState.FullFareConditions;
    if (!isLoading && !error) {
        const fareGroupsCount = compareTable === null || compareTable === void 0 ? void 0 : compareTable.FareGroupsCompareTable.header.length;
        compareFaresSlidesCount = fareGroupsCount < 5 ? fareGroupsCount : 5;
        fullCompareFaresSlidesCount = fareGroupsCount < 3 ? fareGroupsCount : 3;
    }
    const resetSlidersIndex = React.useCallback(() => {
        var _a;
        (_a = topSliderRef.current) === null || _a === void 0 ? void 0 : _a.slickGoTo(0);
        sliders.forEach(slider => slider.slickGoTo(0));
        setCurrentSlide(0);
    }, [topSliderRef, sliders, currentSlide]);
    const handleCompareStateChange = e => {
        var _a;
        e.preventDefault();
        resetSlidersIndex();
        (_a = headerRef === null || headerRef === void 0 ? void 0 : headerRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth' });
        onCompareStateChange(isFullFareConditions ? CompareState.CompareFares : CompareState.FullFareConditions);
    };
    React.useEffect(() => {
        sliders.forEach(slider => slider.slickGoTo(currentSlide));
        if (topSliderRef.current) {
            topSliderRef.current.slickGoTo(currentSlide);
        }
    }, [currentSlide, topSliderRef]);
    const sliderSettings = {
        arrows: false,
        speed: 250,
        swipe: false,
        slidesToShow: isFullFareConditions ? fullCompareFaresSlidesCount : compareFaresSlidesCount,
        infinite: false,
        initialSlide: currentSlide,
        responsive: [
            {
                breakpoint: TABLET_MIN_WIDTH,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { id: "content__table", ref: contentTableRef },
            React.createElement(Header, { onSetCurrentSlide: setCurrentSlide, settings: sliderSettings, compareTableHeader: compareTable === null || compareTable === void 0 ? void 0 : compareTable.FareGroupsCompareTable.header, isFullFareConditions: isFullFareConditions, selectedFare: selectedFare, selectedFareName: selectedFareName, contentTableRef: contentTableRef, topSliderRef: topSliderRef }),
            React.createElement(Content, { sliders: sliders, settings: sliderSettings, compareTableGroups: compareTable === null || compareTable === void 0 ? void 0 : compareTable.FareGroupsCompareTable.groups, isFullFareConditions: isFullFareConditions })),
        React.createElement(Footer, { notes: notes, isFullFareConditions: isFullFareConditions, isLoading: isLoading, error: error, onLinkClick: handleCompareStateChange })));
};
export default FaresSlider;
